import Super from '@simplepractice/ember-messaging-client/models/messaging-user';

export default Super.extend({});
